/*
  Galeria de la seccion "Profesionales: proyectos".

  Los controles solo existen si hay mas de una foto, asi que no hay flechas
  decorativas: lo que se ve siempre hace algo. Sin la galeria activa la
  pagina sigue mostrando la primera foto, que ya viene en el HTML.
*/
if (!customElements.get('pro-gallery')) {
  customElements.define(
    'pro-gallery',
    class ProGallery extends HTMLElement {
      connectedCallback() {
        this.main = this.querySelector('[data-pro-gallery-main]');
        this.thumbs = Array.from(this.querySelectorAll('[data-pro-gallery-thumb]'));
        if (!this.main || this.thumbs.length < 2) return;

        this.index = Math.max(
          0,
          this.thumbs.findIndex((t) => t.getAttribute('aria-current') === 'true')
        );

        this.thumbs.forEach((thumb, i) => {
          thumb.addEventListener('click', () => this.show(i));
        });

        this.querySelectorAll('[data-pro-gallery-step]').forEach((button) => {
          button.hidden = false;
          button.addEventListener('click', () => {
            const step = Number(button.dataset.proGalleryStep) || 1;
            this.show((this.index + step + this.thumbs.length) % this.thumbs.length);
          });
        });
      }

      show(index) {
        const thumb = this.thumbs[index];
        if (!thumb || index === this.index) return;

        this.main.srcset = thumb.dataset.srcset || '';
        this.main.src = thumb.dataset.src || '';
        this.main.alt = thumb.dataset.alt || '';

        this.thumbs.forEach((item, i) => {
          item.setAttribute('aria-current', i === index ? 'true' : 'false');
        });

        this.index = index;
      }
    }
  );
}
